import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, blue } from '../colors';
import { GetThemeOptions } from '../../theme';
import { chronoDefinedDarkTokens, chronoDefinedLightTokens, unitySemanticLightColorTokens } from '@/theme/unityTokens';

export const infoColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          main: unitySemanticLightColorTokens['--semantic-data-informative-informative'],
          highContrast: chronoDefinedLightTokens['--data-informative-informative-high-contrast'],
          lowContrast: chronoDefinedLightTokens['--data-informative-informative-low-contrast'],
        }
      : {
          main: chronoDefinedDarkTokens['--data-informative-informative'],
          highContrast: chronoDefinedDarkTokens['--data-informative-informative-high-contrast'],
          lowContrast: chronoDefinedDarkTokens['--data-informative-informative-low-contrast'],
        };
  }

  return mode === 'light'
    ? {
        main: blue[500],
        highContrast: blue[700],
        lowContrast: blue[100],
      }
    : {
        main: blue[400],
        highContrast: blue[100],
        lowContrast: blue[800],
      };
};
